import DataTable from '../DataTable';
import IpaffsModaltable from './IpaffsModalTable';

const IpaffsModalDetailedViewReadOnly = ({ data }) => {
  return (
    <IpaffsModaltable data={data ?? []}>
      <DataTable.Column colKey="hsCode" key="hsCode" header="HS Code" />
      <DataTable.Column colKey={'Origin'} key={'Origin'} header="Origin" />
      <DataTable.Column colKey={'Description of goods'} key={'Description of goods'} header="Description" />
      <DataTable.Column colKey={'riskCategoryName'} key={'riskCategoryName'} header="Risk Category" />
      <DataTable.Column colKey={'categoryOption'} key={'categoryOption'} header="Confirmed Category" />
      <DataTable.Column colKey={'Gross mass (kg)'} key={'Gross mass (kg)'} header="Gross Weight (Kg)" />
    </IpaffsModaltable>
  );
};

export default IpaffsModalDetailedViewReadOnly;
